import { FormControl } from '@angular/forms';
import { EntityReference, ShoppingSessionReference } from '../../core/api/api.entities';
import { positiveOrZeroNotNull, required, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export class ShoppingSessionFormControls extends BaseFormControls {
  bonus = new FormControl(0.0, positiveOrZeroNotNull);
  date = new FormControl(new Date(), requiredNotNull);
  excluded = new FormControl(0.0, positiveOrZeroNotNull);
  existingShoppingSession = new FormControl<ShoppingSessionReference | null>(null);
  store = new FormControl<EntityReference | null>(null, required);
  total = new FormControl(0.0, positiveOrZeroNotNull);
}
